import { default as Axios } from 'axios';

import { Config } from '@sternum/web/config';

import { appStorage } from '../appStorage';

export const axios = Axios.create({
  baseURL: Config.apiUrl,
});

axios.interceptors.request.use(async (config) => {
  const token = await appStorage.getToken();

  if (token) {
    config.headers!.authorization = `Bearer ${token}`;
  }

  const clientId = window.location.pathname.split('/')[1];

  if (clientId) {
    config.headers!['x-sternum-client'] = clientId;
  }

  return config;
});
